/*
	Удаляем чат
*/
import { deleteSession } from "../../../../../../../../../shared/api/sessions";

export const deleteChatService = async (
	session_id: string,
	user_id: string,
) => {
	const data = await deleteSession({ session_id, user_id });
	return data;
};
